import { Derivative } from "./derivative";
import { FIAT_EARN_TYPE } from "@helpers/constants";

export class FiatEarn extends Derivative {
	protected readonly tradable_actions: string[] = [];

	public getCurrencyType(): string {
		return FIAT_EARN_TYPE;
	}
}
